export function fetchDocumentsList(
  eventId,
  callbackSuccess,
  callbackError,
  params
) {
  return {
    type: "FETCH_DOCUMENTS_LIST",
    payload: {
      eventId,
      callbackSuccess,
      callbackError,
      params,
    },
  };
}

export function setDocumentsList(documentsList) {
  return {
    type: "SET_DOCUMENTS_LIST",
    payload: {
      documentsList,
    },
  };
}

export function setApprovalDocumentsLoading(loading) {
  return {
    type: "SET_APPROVAL_DOCUMENTS_LOADING",
    payload: {
      loading,
    },
  };
}
